import { render } from "./list_edit.vue?vue&type=template&id=18ce3706"
import script from "./list_edit.js?vue&type=script&lang=js"
export * from "./list_edit.js?vue&type=script&lang=js"

import "./list_edit.vue?vue&type=style&index=0&id=18ce3706&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__